import React from 'react';
import "./pie-chart-legend.css"
import LegendItem from "./legend-item-component";
import {getColor} from "../../utilities/getColor";


const PieChartLegend = (
  {
    data,
    valueName,
    value,
    height,
    linkToWord,
    reportUrl
  }
  ) => {

  return (
    <div className="pi_chart_legend" style={{height}}>
      <div className="pi_chart_legend__header">
        <div className="pi_chart_legend__header__item" style={{width: '25%', textAlign: 'center'}}>
          <span>Color</span>
        </div>
        <div className="pi_chart_legend__header__item" style={{width: '35%'}}>
          <span>{valueName}</span>
        </div>
        <div className="pi_chart_legend__header__item">
          <span>Count</span>
        </div>
        <div className="pi_chart_legend__header__item">
          <span>Percent</span>
        </div>
      </div>
      {data.map((d, i) => (
        <LegendItem
          key={i}
          color={getColor({
            fromd3: false,
            d,
            i,
            top: d.term,
            sentiment: d.sentiment,
            primary: d.primary
          })}
          value={d[value]}
          count={d.count}
          percent={d.percent}
          link={linkToWord ? `/word-verbatims?reportUrl=${reportUrl}&word=${d[value]}` : false}
        />
      ))}
    </div>
  )
};



export default PieChartLegend;


// WEBPACK FOOTER //
// ./src/components/pie-chart-legend/pie-chart-legend-component.js